export default __webpack_public_path__ + "static/media/Arsalan.b55e94e2.jpg";